import { IconButton } from 'component/Button'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { PageButton, PageDots } from 'page/catalog/Pagination/PageButton'
import { useDemo } from 'page/catalog/store/CatalogContext'

function getPageItems(page: number, pages: number): number[] {
  page = Math.max(0, Math.min(page, pages - 1))
  const items: number[] = []
  const last = pages - 1
  const left = page - 1
  const right = last - page - 1
  items.push(0)
  if (page > 2 && pages > 5) items.push(-1)
  if (left > 2 && page === last) items.push(page - 3)
  if (left > 1 && right <= 0) items.push(page - 2)
  if (left > 0) items.push(page - 1)
  if (left >= 0 && right >= 0) items.push(page)
  if (right > 0) items.push(page + 1)
  if (right > 1 && left <= 0) items.push(page + 2)
  if (right > 2 && page === 0) items.push(page + 3)
  if (page < last - 2 && pages > 5) items.push(-2)
  if (last > 0) items.push(last)
  return items
}

function renderItem(item: number) {
  if (item < 0) return <PageDots key={item} />
  return <PageButton key={item} page={item} />
}

export const Pages = observer(() => {
  const demo = useDemo()
  const { page, pages } = demo.form
  const items = getPageItems(page, pages)

  const onLeft = useLatestCallback(() => {
    demo.form.page--
  })

  const onRight = useLatestCallback(() => {
    demo.form.page++
  })

  if (pages < 2) return <Space />

  return <Space gap={4}>
    <IconButton disabled={page <= 0} action={onLeft}>
      <Icon size={16} name="keyboard_arrow_left" />
    </IconButton>

    {items.map(item => renderItem(item))}

    <IconButton disabled={page >= pages - 1} action={onRight}>
      <Icon size={16} name="keyboard_arrow_right" />
    </IconButton>
  </Space>
})
